var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.3335C17.5 15.1668 10 20.1668 10 20.1668C10 20.1668 2.5 15.1668 2.5 9.3335C2.5 7.34437 3.29018 5.43672 4.6967 4.03019C6.10322 2.62367 8.01088 1.8335 10 1.8335C11.9891 1.8335 13.8968 2.62367 15.3033 4.03019C16.7098 5.43672 17.5 7.34437 17.5 9.3335Z",
    stroke: "#0A84FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.8335C11.3807 11.8335 12.5 10.7142 12.5 9.3335C12.5 7.95278 11.3807 6.8335 10 6.8335C8.61929 6.8335 7.5 7.95278 7.5 9.3335C7.5 10.7142 8.61929 11.8335 10 11.8335Z",
    stroke: "#0A84FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinHeader);
export default __webpack_public_path__ + "static/media/mapPinHeader.0ebf8c7ac4ec1205fa3aee8c415daa18.svg";
export { ForwardRef as ReactComponent };